<template>
	<div :class="`formulate-input-element formulate-input-element--${context.type}`" :data-type="context.type"></div>
</template>

<script>
export default {
	props: {
		context: {
			type: Object,
			required: true
		}
	},
	computed: {
		formatted: {
			get: function() {
				return this.context.model
			},
			set: function(newValue) {
				this.context.model = newValue
			}
		}
	}
}
</script>

<style scoped>
.formulate-input-element {
	display: none;
}
</style>
